<style></style>
<template>
  <v-content pa-0>
    <Header></Header>
    <!-- Data & stats single banner -->
    <div style="
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
      " :style="$vuetify.breakpoint.mdAndUp ? { 'padding-top': '88px' } : {}">
      <v-img
        :src="$vuetify.breakpoint.smAndDown ? http + dataAndStatsBanner.mobile_img : http + dataAndStatsBanner.desktop_img"
        max-height="500px" style="width: 100%"></v-img>
    </div>

    <loading :active.sync="isLoading"></loading>
    <!-- Creative index Tab <Country> -->
    <!--      <v-layout justify-center style="background-color: white">-->
    <v-flex xs12>
      <span v-for="(item, i) in powerBiDataCategory" :key="i">
        <v-layout justify-start>
          <v-flex class="headTab" py-3 px-5>
            <v-icon large color="#FF5100" class="mx-5">bar_chart</v-icon>
            <div class="text-start">
              <template v-if="language == 'en'">{{ item.subject_en }}</template>
              <template v-else>{{ item.subject_th }}</template>
            </div>
          </v-flex>
        </v-layout>
        <div style="display: grid; justify-items: center;  margin-top: 20px;">
          <div class="subject"
            style="background: var(--gradient-1, linear-gradient(90deg, #EF5322 50%, #711B00 103.83%));text-align: left;display: flex;align-items: center ; padding: 16px 12px;">
            <svg style="margin-right: 10px;" xmlns="http://www.w3.org/2000/svg" width="29px" height="29px"
              viewBox="0 0 512 512">
              <g transform="rotate(90 256 256)">
                <path fill="#d9d9d9" d="M256 32L20 464h472L256 32z" />
              </g>
            </svg>
            <p class="subject m-0" v-if="language == 'en'">{{ item.subject_en }} </p>
            <p class="subject m-0" v-else>{{ item.subject_th }} </p>
          </div>
        </div>
        <div class="row ma-0 pa-0 mt-5 my-0 py-0">
          <v-flex xs12 v-if="language == 'en'">
            <PowerBiPanel :embed_url="item.embed_url_en"></PowerBiPanel>
          </v-flex>
          <v-flex xs12 v-else>
            <PowerBiPanel :embed_url="item.embed_url_th"></PowerBiPanel>
          </v-flex>
          <p style="text-align: left" class="px-5"><a target="_blank" :href="item.link">{{ item.link }}</a></p>
        </div>

      </span>
      <Footer></Footer>
    </v-flex>
    <!--      </v-layout>-->

    <v-dialog content-class="overflow-dialog" width="900"> </v-dialog>
  </v-content>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { domain } from "../services/Constants";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PowerBiPanel from "../components/PowerBIPanel";
import Service from "../services";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import * as pbi from "powerbi-client";
import StatCards from "../components/StatCards";

export default {
  name: "country",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    StatCards,
    Header,
    Footer,
    Loading,
    PowerBiPanel,
  },
  data: () => ({
    http: domain,
    isLoading: true,
    output: null,
    interPowerBiTopic: false,
    countryPowerBiTopic: false,
    overviewStatCards: [],
    articles: [],
    countryData: {},
    interData: {},
    textHere: "international",
  }),
  computed: {
    ...mapState({
      overviewBanner: state => state.banner.overviewBanner,
      countryBanner: (state) => state.banner.countryBanner,
      dataAndStatsBanner: (state) => state.banner.dataAndStatsBanner,
      powerBiDataCountry: (state) => state.power_bi.powerBiDataCountry,
      powerBiDataCategory: state => state.power_bi.powerBiDataCategory,

      // powerBiEmbed: (state) => state.power_bi.powerBi,
      language: (state) => state.locale.language,
    }),
  },
  watch: {
    language: function () {
      // Force reload
      this.isLoading = true;
      this.$nextTick(() => {
        this.isLoading = false;
      });
    },
  },
  async created() {
    console.log('banner', this.overviewBanner);
    await Service.analytics.sendPageView({
      path: this.$route.path,
    });
    await this.$store.dispatch("banner/onGetAllBanners");
    await this.$store.dispatch("power_bi/onGetAllPowerBi");
    await this.initData();
    // this.getArticles();
    // this.countryData = this.powerBiEmbed["country-power-bi"];
    // this.interData = this.powerBiEmbed["international-power-bi"];
    // await this.createPowerBiDashboard(this.powerBiEmbed['international-power-bi'], 'international-power-bi')
    // await this.createPowerBiDashboard(this.powerBiEmbed['country-power-bi'], 'country-power-bi')
    this.isLoading = false;
    console.log("powerBiDataCountry");
    console.log(this.powerBiDataCountry);
  },
  beforeUpdate() {
    document.getElementsByTagName("iframe").forEach((element) => {
      element.classList.add("responsive-iframe");
    });
  },
  methods: {
    ...mapActions("overview", ["onGetAllDataTopic"]),
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    async initData() {
      this.isLoading = true;
      this.interPowerBiTopic = "international-power-bi-topic";
      this.countryPowerBiTopic = "country-power-bi-topic";
      this.isLoading = false;
      this.page = "overview";
      Service.statsbox.getAllStatBox(this.page).then((res) => {
        this.overviewStatCards = res;
      });
    },

    async createPowerBi(power_bi, div_id) {
      let models = pbi.models;
      let permissions = models.Permissions.All;
      var config = {
        type: "report",
        tokenType: models.TokenType.Embed,
        accessToken: power_bi.access_token,
        embedUrl_th: power_bi.embed_url_th,
        embedUrl_en: power_bi.embed_url_en,
        id: power_bi.report_id,
        permissions: permissions,
        settings: {
          panes: {
            filters: {
              visible: true,
            },
            pageNavigation: {
              visible: true,
            },
          },
        },
      };

      let embedContainer = document.getElementById(div_id);
      // eslint-disable-next-line no-undef
      let report = powerbi.embed(embedContainer, config);
      report.off("loaded");
      report.on("loaded", function () {
        console.log("Loaded");
      });
      report.off("rendered");
      report.on("rendered", function () {
        console.log("Rendered");
      });
      report.on("error", function (event) {
        console.log(event.detail);
        report.off("error");
      });
      report.off("saved");
      report.on("saved", function (event) {
        console.log(event.detail);
        if (event.detail.saveAs) {
          console.log(
            "In order to interact with the new report, create a new token and load the new report"
          );
        }
      });
    },
    createPowerBiDashboard(power_bi, div_id) {
      let models = pbi.models;

      let config = {
        type: "dashboard",
        tokenType: models.TokenType.Embed,
        accessToken: power_bi.access_token,
        embedUrl: power_bi.embed_url,
        id: power_bi.report_id,
        settings: {
          layoutType: models.LayoutType.Custom,
          customLayout: {
            displayOption: models.DisplayOption.FitToPage,
          },
        },
        pageView: "fitToWidth",
      };

      let dashboardContainer = document.getElementById(div_id);
      // eslint-disable-next-line no-undef
      let dashboard = powerbi.embed(dashboardContainer, config);
      dashboard.off("loaded");
      dashboard.on("loaded", function () {
        console.log("Loaded");
      });
      dashboard.on("error", function (event) {
        console.log(event.detail);

        dashboard.off("error");
      });
      dashboard.off("tileClicked");
      dashboard.on("tileClicked", function (event) {
        console.log(event.detail);
      });
    },
    getArticles() {
      Service.webdata.getArticlesMode("overview").then((res) => {
        this.articles = res.data.map((item) => {
          return {
            ...item,
            img_cover_path:
              "https://data.cea.or.th/service" + "/" + item.img_cover_path,
          };
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.tabSection {
  border-top: 1px solid #ff5100;
  border-bottom: 1px solid #ff5100;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 20px;
  font-weight: bold;
  color: #ff5100;
  user-select: none;
  cursor: pointer;
}

.tabSection-mobile {
  font-size: 16px;
}

.tabActive {
  background: #ff5100;
  color: #fff;
}

.txtDetail {
  font-size: 18px;
  font-weight: bold;
  color: #1d1d1b;
  width: 100%;
}

.categoryIcon {
  user-select: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid #ff5100;
  cursor: pointer;
  width: 143px;
  height: 150px;
  align-items: center;
}

.categoryIcon img {
  width: 55px;
  margin-bottom: 10px;
}

.categoryIcon:hover {
  background: rgba(255, 81, 0, 0.15);
}

.categoryIconHover:hover,
.categoryIconHover {
  background: rgba(255, 81, 0, 0.35);
}

.headTab {
  background: #000;
  color: #fff;
  text-transform: uppercase;
  font-size: 20px;
  display: flex;
  align-items: center;
}

.tableHeadTab {
  background: #000;
  color: #fff;
  text-transform: uppercase;
  font-size: 28px;
  display: flex;
}

.tableTxt {
  font-size: 17px;
  color: #fff !important;
}

th.tdHead {
  background-color: #ff5100;
  font-size: 15px;
  color: #fff;
}

/*.theme--light.v-data-table tbody th {*/
/*    position: -webkit-sticky !important; !* for Safari *!*/
/*    position: sticky !important;*/
/*    left: 0 !important;*/
/*}*/

/*.themem--light.v-data-table thead th:first-child {*/
/*    position: -webkit-sticky !important; !* for Safari *!*/
/*    position: sticky !important;*/
/*    left: 0;*/
/*    z-index: 1;*/
/*}*/

.theme--light.v-data-table thead tr th,
.theme--light.v-data-table tbody tr td {

  &:nth-child(1),
  &:nth-child(2) {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
  }

  &:nth-child(2) {
    left: 146.4px;
  }
}

.theme--light.v-data-table thead tr th {
  background-color: #000;
}

.theme--light.v-data-table tbody tr td {
  background-color: #fff;
}

.theme--light.v-data-table tbody th:first-child {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
}

/* table border style */
.theme--light.v-data-table tbody tr td {
  border-bottom: 1px solid #ff5100 !important;
}

.theme--light.v-data-table thead tr th:nth-child(odd):not(:first-child),
.theme--light.v-data-table tbody tr td:nth-child(odd):not(:first-child) {
  color: #ff5100 !important;
}

.theme--light.v-data-table tbody tr td:not(:last-child),
.theme--light.v-data-table thead tr:last-child th:not(:last-child) {
  border-right: 1px solid #ff5100;
}

/* end table border style */
</style>
